import React, { useEffect, useState } from "react";
import UserMenu from "../../components/layouts/UserMenu";
import Layout from "../../components/layouts/Layout";
import axios from "axios";
import { useAuth } from "../../context/auth";
import moment from "moment";
import { Link } from "react-router-dom";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [auth] = useAuth();

  const getOrders = async () => {
    try {
      const { data } = await axios.get(
        "https://urbancart-ecommerce-store.onrender.com/api/v1/auth/orders"
      );
      setOrders(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (auth?.token) getOrders();
  }, [auth?.token]);

  return (
    <Layout title={"Your Orders"}>
      <div className="container-fluid p-4 dashboard">
        <div className="row">
          <div className="col-md-3">
            <UserMenu />
          </div>
          <div className="col-md-9">
            <h1 className="text-center mb-4">Your Orders</h1>
            {orders.length === 0 ? (
              <div className="text-center my-5">
                <h2 className="text-muted">No orders yet! 😔</h2>
                <p>
                  Looks like you haven’t purchased anything. Start shopping to
                  fill this page with awesome products!
                </p>
                <Link to="/" className="btn btn-primary">
                  Shop Now
                </Link>
              </div>
            ) : (
              orders?.map((o, i) => (
                <div className="card mb-4 shadow-lg border-0" key={i}>
                  <div className="card-header bg-success text-white">
                    <h5>Order #{i + 1}</h5>
                    <small>
                      {moment(o?.createdAt).format("MMMM Do YYYY, h:mm:ss a")}
                    </small>
                  </div>
                  <div className="card-body">
                    <h6>Status: {o?.status}</h6>
                    <h6>Buyer: {o?.buyer?.name}</h6>
                    <h6>
                      Payment: {o?.payment.success ? "Success" : "Failed"}
                    </h6>
                    <h6>Items: {o?.products?.length}</h6>
                    <hr />
                    <div className="container-fluid">
                      {o?.products?.map((p, index) => (
                        <div
                          className="row mb-2 align-items-center"
                          key={index}
                        >
                          <div className="col-md-2">
                            <img
                              src={`https://urbancart-ecommerce-store.onrender.com/api/v1/product/get-photo/${p._id}`}
                              className="img-fluid rounded shadow-sm"
                              alt={p.name}
                            />
                          </div>
                          <div className="col-md-8">
                            <Link to={`/product/${p.slug}`}>
                              <h5 className="">{p.name}</h5>
                            </Link>
                            <p>{p.description.substring(0, 50)}...</p>
                            <p className="text-success font-weight-bold">
                              Price:{" "}
                              {p.price.toLocaleString("en-US", {
                                style: "currency",
                                currency: "INR",
                              })}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="card-footer text-muted">
                    Ordered {moment(o?.createdAt).fromNow()}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Orders;

// import React, { useEffect, useState } from "react";
// import UserMenu from "../../components/layouts/UserMenu";
// import Layout from "../../components/layouts/Layout";
// import axios from "axios";
// import { useAuth } from "../../context/auth";
// import moment from "moment";
// import { Link } from "react-router-dom";

// const Orders = () => {
//   const [orders, setOrders] = useState([]);
//   const [auth, setAuth] = useAuth();

//   const getOrders = async () => {
//     try {
//       const { data } = await axios.get("https://urbancart-ecommerce-store.onrender.com/api/v1/auth/orders");
//       setOrders(data);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     if (auth?.token) getOrders();
//   }, [auth?.token]);

//   return (
//     <Layout title={"Your Orders"}>
//       <div className="container-fluid p-4 dashboard">
//         <div className="row">
//           <div className="col-md-3">
//             <UserMenu />
//           </div>
//           <div className="col-md-9">
//             <h1 className="text-center mb-4">Your Orders</h1>
//             {orders.length === 0 ? (
//               <div className="text-center my-5">
//                 <h2 className="text-muted">No orders yet! 😔</h2>
//                 <p>Looks like you haven’t purchased anything. Start shopping to fill this page with awesome products!</p>
//                 <Link to="/" className="btn btn-primary">Shop Now</Link>
//               </div>
//             ) : (
//               { orders?.map((o, i) => (
//                 <div className="card mb-4 shadow-lg border-0" key={i}>
//                   <div className="card-header bg-success text-white">
//                     <h5>Order #{i + 1}</h5>
//                     <small>{moment(o?.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</small>
//                   </div>
//                   <div className="card-body">
//                     <h6>Status: {o?.status}</h6>
//                     <h6>Buyer: {o?.buyer?.name}</h6>
//                     <h6>Payment: {o?.payment.success ? "Success" : "Failed"}</h6>
//                     <h6>Items: {o?.products?.length}</h6>
//                     <hr />
//                     <div className="container-fluid">
//                       {o?.products?.map((p, index) => (
//                         <div className="row mb-2 align-items-center" key={index}>
//                           <div className="col-md-2">
//                             <img
//                               src={`https://urbancart-ecommerce-store.onrender.com/api/v1/product/get-photo/${p._id}`}
//                               className="img-fluid rounded shadow-sm"
//                               alt={p.name}
//                             />
//                           </div>
//                           <div className="col-md-8">
//                             <Link to={`/product/${p.slug}`}>
//                               <h5 className="">{p.name}</h5>
//                             </Link>
//                             <p>{p.description.substring(0, 50)}...</p>
//                             <p className="text-success font-weight-bold">Price: ${p.price}</p>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                   <div className="card-footer text-muted">
//                     Ordered {moment(o?.createdAt).fromNow()}
//                   </div>
//                 </div>
//               ))}
//           )}
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default Orders;

// // import React, { useEffect, useState } from "react";
// // import UserMenu from "../../components/layouts/UserMenu";
// // import Layout from "../../components/layouts/Layout";
// // import axios from "axios";
// // import { useAuth } from "../../context/auth";
// // import moment from "moment";

// // const Orders = () => {
// //   const [orders, setOrders] = useState([]);
// //   const [auth, setAuth] = useAuth();
// //   const getOrders = async () => {
// //     try {
// //       const { data } = await axios.get("https://urbancart-ecommerce-store.onrender.com/api/v1/auth/orders");
// //       setOrders(data);
// //     } catch (error) {
// //       console.log(error);
// //     }
// //   };

// //   useEffect(() => {
// //     if (auth?.token) getOrders();
// //   }, [auth?.token]);
// //   return (
// //     <Layout title={"Your Orders"}>
// //       <div className="container-fluid p-3 m-3 dashboard">
// //         <div className="row">
// //           <div className="col-md-3">
// //             <UserMenu />
// //           </div>
// //           <div className="col-md-3">
// //             <h1 className="text-center">All Orders</h1>
// //             {orders?.map((o, i) => {
// //               return (
// //                 <div className="border shadow">
// //                   <table className="table">
// //                     <thead>
// //                       <tr>
// //                         <th scope="col">#</th>
// //                         <th scope="col">Status</th>
// //                         <th scope="col">Buyer</th>
// //                         <th scope="col">Date</th>
// //                         <th scope="col">Payment</th>
// //                         <th scope="col">Quantity</th>
// //                       </tr>
// //                     </thead>
// //                     <tbody>
// //                       <tr>
// //                         <td>{i + 1}</td>
// //                         <td>{o?.status}</td>
// //                         <td>{o?.buyer?.name}</td>
// //                         <td>{moment(o?.createAt).fromNow()}</td>
// //                         <td>{o?.payment.success ? "Success" : "Failed"}</td>
// //                         <td>{o?.products?.length}</td>
// //                       </tr>
// //                     </tbody>
// //                   </table>
// //                   <div className="container">
// //                     {o?.products?.map((p, i) => (
// //                       <div className="row mb-2 p-3 card flex-row" key={p._id}>
// //                         <div className="col-md-4">
// //                           <img
// //                             src={`https://urbancart-ecommerce-store.onrender.com/api/v1/product/get-photo/${p._id}`}
// //                             className="card-img-top"
// //                             alt={p.name}
// //                             width="100px"
// //                             height={"100px"}
// //                           />
// //                         </div>
// //                         <div className="col-md-8">
// //                           <p>{p.name}</p>
// //                           <p>{p.description.substring(0, 30)}</p>
// //                           <p>Price : {p.price}</p>
// //                         </div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 </div>
// //               );
// //             })}
// //           </div>
// //         </div>
// //       </div>
// //     </Layout>
// //   );
// // };

// // export default Orders;
